export const USER_KYC_UPLOADING = 'account/kyc/user_kyc_uploading';
